/*
    플랫폼
*/
export const PLATFORM = {
    PURPLE: {
        LAUNCHER: 'purpleLauncher',
        INAPP: 'purpleInApp',
        WEBVIEW: 'purpleWebview',
        APP: 'purpleApp', // 퍼플 모바일앱 인앱브라우저 + 웹뷰
    },
    COMMUNITY_SDK: 'communitySDK',
    APP: 'app',
    MOBILE_WEB: 'mobileWeb',
    PC_WEB: 'pcWeb'
};

/*
    디바이스
*/
export const DEVICE = {
    PC: {
        key: 'pc',
        platform: [PLATFORM.PC_WEB, PLATFORM.PURPLE.LAUNCHER]
    },
    MOBILE: {
        key: 'mobile',
        platform: [PLATFORM.MOBILE_WEB, PLATFORM.APP, PLATFORM.PURPLE.APP, PLATFORM.PURPLE.INAPP, PLATFORM.PURPLE.WEBVIEW]
    }
};

/*
    플랫폼별 UserAgent
    - 소문자로 입력하기 (toLowerCase)
*/
export const USER_AGENT = {
    [PLATFORM.PURPLE.LAUNCHER]: ['ngpclient'],
    [PLATFORM.PURPLE.INAPP]: ['ncmtalk', 'nctmtalk', 'ncjmtalk'], // 인앱브라우저 ua 오기 전까지 app ua로 설정
    [PLATFORM.PURPLE.WEBVIEW]: ['ncmtalk', 'nctmtalk', 'ncjmtalk'], // 웹뷰 ua 오기 전까지 app ua로 설정
    [PLATFORM.COMMUNITY_SDK]: ['community'],
    [PLATFORM.APP]: ['ncmop', 'nc noob', 'webview_aos', 'webview_ios', 'unrealengine', 'ncmtalk', 'playstation'],
    [PLATFORM.MOBILE_WEB]: ['android', 'webos', 'iphone', 'ipad', 'ipod', 'blackberry', 'iemobile', 'opera mini']
};

/*
    useGameStart: 'download'일 때, 플랫폼 데이터
    icon은 기본적으로 css에 선언되어 있으며, 다른 icon 필요할 때 icon url을 넣어주면 생성하도록 작업함
*/
export const DOWNLOAD_PLATFORM = {
    googlePlay: {
        platform: 'googlePlay',
        name: 'Google Play',
        url: '',
        icon: '',
        target: '_blank'
    },
    appStore: {
        platform: 'appStore',
        name: 'App store',
        url: '',
        icon: '',
        target: '_blank'
    },
    purple: {
        platform: 'purple',
        name: 'PURPLE',
        url: '',
        icon: '',
        target: '_blank'
    },
    playstation4: {
        platform: 'playstation4',
        name: 'Playstation 4',
        url: '',
        icon: '',
        target: '_blank'
    },
    playstation5: {
        platform: 'playstation5',
        name: 'Playstation 5',
        url: '',
        icon: '',
        target: '_blank'
    },
    xBox: {
        platform: 'xBox',
        name: 'X BOX',
        url: '',
        icon: '',
        target: '_blank'
    },
    steam: {
        platform: 'steam',
        name: 'Steam',
        url: '',
        icon: '',
        target: '_blank'
    },
    epicGames: {
        platform: 'epicGames',
        name: 'Epic games',
        url: '',
        icon: '',
        target: '_blank'
    },
    oneStore: {
        platform: 'oneStore',
        name: 'One store',
        url: '',
        icon: '',
        target: '_blank'
    },
    galaxyStore: {
        platform: 'galaxyStore',
        name: 'Galaxy store',
        url: '',
        icon: '',
        target: '_blank'
    }
};
